module.exports = "https://cdn.thelire.com/ins/resource/lh_app_vip_crown.29e90c65c9fae595a15879072acd3e8e.png";